/**
 * Asynchronously loads the component
 */

import { lazyLoad } from 'utils/loadable';

export const ItemInformation = lazyLoad(
  () => import('./index'),
  module => module.ItemInformation,
);
